  (function() {
    function updateCartDrawer(parsedState) {
      // Only update the cart drawer section, do NOT touch the header icon
      if (parsedState.sections && parsedState.sections['cart-drawer']) {
        var existingDrawer = document.querySelector('cart-drawer');
        if (existingDrawer) {
          existingDrawer.outerHTML = parsedState.sections['cart-drawer'];
        }
      }

      // Open the (possibly newly replaced) drawer
      var newDrawer = document.querySelector('cart-drawer');
      if (newDrawer) {
        if (typeof newDrawer.open === 'function') {
          newDrawer.open();
        } else {
          newDrawer.setAttribute('open', 'open');
        }
      }
    }

    function updateCartCount(qtyToAdd) {
      var icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;

      var bubble = icon.querySelector('.cart-count-bubble');
      var countSpan;

      // If there is no bubble yet (cart was empty), create it
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';

        countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        countSpan.textContent = '0';

        var srSpan = document.createElement('span');
        srSpan.className = 'visually-hidden';
        srSpan.textContent = '';

        bubble.appendChild(countSpan);
        bubble.appendChild(srSpan);
        icon.appendChild(bubble);
      } else {
        countSpan = bubble.querySelector('span[aria-hidden="true"]');
        if (!countSpan) {
          countSpan = document.createElement('span');
          countSpan.setAttribute('aria-hidden', 'true');
          bubble.insertBefore(countSpan, bubble.firstChild);
        }
      }

      var current = parseInt((countSpan.textContent || '0').replace(/[^\d]/g, ''), 10);
      if (isNaN(current)) current = 0;

      var newCount = current + qtyToAdd;
      countSpan.textContent = newCount;

      var srSpan2 = bubble.querySelector('.visually-hidden');
      if (srSpan2) {
        // No translation here, but at least keep number in sync
        srSpan2.textContent = newCount;
      }
    }

    function handleUpsellSubmit(form) {
      if (!form || form.dataset.kwUpsellLoading === 'true') return;

      form.dataset.kwUpsellLoading = 'true';

      var formData = new FormData(form);
      var qty = parseInt(formData.get('quantity') || '1', 10);
      if (isNaN(qty) || qty < 1) qty = 1;

      // Only ask Shopify to render the cart drawer section
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function(parsedState) {
          updateCartDrawer(parsedState);
          updateCartCount(qty);
        })
        .catch(function(error) {
          console.error('Upsell add-to-cart error:', error);
          // Fallback: at least try to open the drawer via existing click handler
          var cartIcon = document.getElementById('cart-icon-bubble');
          if (cartIcon) cartIcon.click();
        })
        .finally(function() {
          form.dataset.kwUpsellLoading = 'false';
        });
    }

    // Intercept submit on upsell forms only
    document.addEventListener('submit', function(event) {
      var form = event.target.closest('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      event.preventDefault();
      handleUpsellSubmit(form);
    });

    // Make the entire upsell banner clickable (delegated)
    document.addEventListener('click', function(event) {
      var banner = event.target.closest('.kw-upsell__inner[data-kw-upsell-click]');
      if (!banner) return;

      var form = banner.querySelector('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      // If user clicked directly on the upsell button, let the submit handler handle it
      var clickOnButton = event.target.closest('button');
      if (clickOnButton && clickOnButton.closest('.kw-upsell__form')) {
        return;
      }

      event.preventDefault();

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  })();
